import React from 'react';

import { useRouter } from 'next/router';

import Tags from 'src/components/Tags';
import { TagProps, TagTypes } from 'src/components/Tags/types';
import { colors } from 'src/styles/colors';
import { thumbnailPropertySetter } from 'src/utils/analytics/mixpanel/propertySetter';
import {
  generateCardsUrl,
  navigationHandler
} from 'src/utils/cardsUrlGenerator';
import { CountryCode } from 'src/utils/constants/stringConstants';
import { convertTimeToHumanReadableFormat } from 'src/utils/convertTimeToHumanReadableFormatUtil';

import { useAppStore } from 'src/hooks/useAppStore';
import ThumbnailImage from '../../components/ThumbnailImage';
import { ThumbnailComponentProps } from '../../types';
import * as customStyled from './styles';

const Plex: React.FC<ThumbnailComponentProps> = ({
  title,
  tagName,
  imageUrl,
  slug,
  assetSubType,
  genres,
  ageRating,
  duration,
  assetType,
  businessType,
  billingType,
  content,
  thumbnailType,
  contentPartner,
  content_partner_details,
  joystickIconCheck,
  dataTestId
}) => {
  const { appConfig, usersLocationData } = useAppStore();
  const router = useRouter();
  const generateTags = (): TagProps[] => {
    return [
      {
        tagType: TagTypes.TEXT,
        spaceX: '8',
        spaceY: '4',
        text: (genres && genres[0]) || '',
        textColor: colors.PrimaryWhiteColorAlpha70,
        fontSize: 14,
        fontWeight: 400
      },
      {
        tagType: TagTypes.TEXT,
        spaceX: '0',
        spaceY: '0',
        text: convertTimeToHumanReadableFormat(duration),
        textColor: colors.PrimaryWhiteColorAlpha70,
        fontSize: 14,
        fontWeight: 400,
        showDot: !!duration
      },
      {
        tagType: TagTypes.TEXT,
        spaceX: '0',
        spaceY: '0',
        text: ageRating || '',
        textColor: colors.PrimaryWhiteColorAlpha70,
        fontSize: 14,
        fontWeight: 400,
        showDot: !!ageRating
      }
    ];
  };
  let slugData = content ? generateCardsUrl(content) ?? slug : '';

  if (slugData) {
    slugData = slugData.startsWith('/')
      ? slugData
      : slugData.startsWith('http')
      ? slugData
      : `/${slugData}`;
  }
  if (
    appConfig.isRequestedByBot &&
    usersLocationData?.country_code !== CountryCode.IN
  ) {
    const globalRegex = /\/global\//;
    slugData = slugData
      .replace(globalRegex, '/')
      .replace(`/${router.locale}/`, '/');
  }
  const watchCallback = (e: any) => {
    e.preventDefault();
    if (slugData) {
      thumbnailPropertySetter({
        item: {
          title,
          imageUrl,
          businessType,
          billingType,
          assetSubType,
          link: slug,
          contentPartner,
          content_partner_details
        }
      });
      navigationHandler(slugData, (slugData) =>
        router.push(slugData, slugData)
      );
    }
  };

  return (
    <div
      title={title}
      className="keen-slider__slide"
      css={customStyled.container}
      data-testid={dataTestId}>
      <ThumbnailImage
        imageUrl={imageUrl}
        tagName={tagName}
        assetType={assetType}
        title={title}
        slug={slugData}
        businessType={businessType}
        billingType={billingType}
        onClickHandler={watchCallback}
        thumbnailType={thumbnailType}
        contentPartner={contentPartner}
        content_partner_details={content_partner_details}
        joystickIconCheck={joystickIconCheck}
      />
      <footer css={customStyled.plexCardMetaContainer}>
        <div css={customStyled.plexCardMetaDetail}>
          <h3 css={customStyled.thumbnailTitleWrapper}>
            <span css={customStyled.thumbnailTitle}>{title}</span>
          </h3>
          {<Tags tags={generateTags()} spaceX="8" spaceY="8" />}
        </div>
      </footer>
    </div>
  );
};

export default Plex;
